export const ICON_SIZE = 14;
export const COPY_ICON_SIZE = 12;